import {
  getFlightMarkersState,
  getGCPRequestState,
  getSiteState,
  IStoreState,
} from "../../rootReducer";
import { getSiteSrs, ISiteState } from "../../modules/site/reducer";
import { getAllGcps, getToBeCheckedGcps } from "../gpcExporters";

const LAT_LON_PRECISION = 7;

const t = (tabs: number) => "    ".repeat(tabs);
const gpx = (tabs: number) =>
  t(tabs) +
  [
    "<gpx",
    'xmlns="http://www.topografix.com/GPX/1/1"',
    'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"',
    'xsi:schemaLocation="http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd"',
    'version="1.1"',
    'creator="traceair"',
    ">",
  ].join(" ");

const metadata = (tabs: number) => `${t(tabs)}<metadata/>`;

const wpt = (tabs: number, lat: number, lng: number, name: string): string =>
  [
    t(tabs) +
      `<wpt lat="${Number(lat.toFixed(LAT_LON_PRECISION))}" lon="${Number(
        lng.toFixed(LAT_LON_PRECISION),
      )}">`,
    t(tabs + 1) + `<name>${name}</name>`,
    t(tabs) + `</wpt>`,
  ].join("\n");

const ensureSrs = (siteState: ISiteState) => {
  const srs = getSiteSrs(siteState);
  if (!srs) {
    throw new Error("Can't generate GCP Request GPX File without SRS info");
  }
};

export function createGpxFileAll(state: IStoreState): string {
  const siteState: ISiteState = getSiteState(state);
  ensureSrs(siteState);

  const gpxFileContentParts = [gpx(0), metadata(1)]; // content of GPX file

  const gcps = getAllGcps(
    getGCPRequestState(state),
    getFlightMarkersState(state),
    getSiteState(state),
    "wgs84",
  );
  const gcpsStr = gcps
    .map((gcp) => {
      return wpt(1, gcp.y, gcp.x, gcp.name);
    })
    .join("\n");
  gpxFileContentParts.push(gcpsStr);

  return [...gpxFileContentParts, "</gpx>"].join("\n");
}

export function createGpxFileProblem(state: IStoreState): string {
  const siteState: ISiteState = getSiteState(state);
  ensureSrs(siteState);

  const gpxFileContentParts = [gpx(0), metadata(1)]; // content of GPX file

  const gcps = getToBeCheckedGcps(
    getGCPRequestState(state),
    getFlightMarkersState(state),
    getSiteState(state),
    "wgs84",
  );
  const gcpsStr = gcps
    .map((gcp) => {
      return wpt(1, gcp.y, gcp.x, gcp.name);
    })
    .join("\n");
  gpxFileContentParts.push(gcpsStr);

  return [...gpxFileContentParts, "</gpx>"].join("\n");
}
